import { Event } from './event';
import { InvoiceBatchCreatedEventPayload } from './invoice-batch-created-event-payload';

export class InvoiceBatchCreatedEvent extends Event<InvoiceBatchCreatedEventPayload> {}
